import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "project" }
const _hoisted_2 = ["href"]
const _hoisted_3 = ["href"]
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" パスワード：********")
const _hoisted_7 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ul", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.projects, (p) => {
        return (_openBlock(), _createElementBlock("li", {
          key: p.id
        }, [
          _createElementVNode("h4", null, [
            _createElementVNode("a", {
              href: p.url,
              target: "_blank"
            }, _toDisplayString(p.name), 9, _hoisted_2)
          ]),
          _createElementVNode("ul", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(p.metas, (m) => {
              return (_openBlock(), _createElementBlock("li", {
                key: m.id
              }, [
                _createElementVNode("h6", null, [
                  _createElementVNode("a", {
                    href: m.url,
                    target: "_blank"
                  }, _toDisplayString(m.name), 9, _hoisted_3)
                ]),
                _createElementVNode("ul", null, [
                  (m.username)
                    ? (_openBlock(), _createElementBlock("li", _hoisted_4, "ユーザー名：" + _toDisplayString(m.username), 1))
                    : _createCommentVNode("", true),
                  (m.password)
                    ? (_openBlock(), _createElementBlock("li", _hoisted_5, [
                        _hoisted_6,
                        _createElementVNode("button", {
                          class: "btn btn-link",
                          onClick: ($event: any) => (_ctx.copyPassword($event, m.password))
                        }, " コピー ", 8, _hoisted_7)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]))
            }), 128))
          ])
        ]))
      }), 128))
    ])
  ]))
}